<div [formGroup]="form">


    <div class="row" >
        <div class="col-md-6 col-xs-12">
            <div class="controls-group">     
                <div *ngIf="isSocialID_Mandarory">                   
                    <label mandatory >
                        {{label_social_id}}
                    </label>
                </div>
                <div *ngIf="!isSocialID_Mandarory">
                    <label >
                        {{label_social_id}}
                    </label>
                </div>
                <div class="input-group">
                    <input type="text" class="form-control txt" maxlength="9" minlength="7"
                        formControlName="social_id" digitalOnly
                        placeholder="{{placeholderSocialId}}" (focusout)="checkIfExistsID()"
                    />
                    <control-messages [control]="f.social_id"></control-messages>
                </div>
            </div>
        </div>
        <div  class="col-md-6 col-xs-12">
            <div class="controls-group">
                <label mandatory>
                    מין
                </label>
                <div class="input-group" style="margin-top: 6px">
                    <label class="form-radio-label">
                        <input type="radio" formControlName="sex" checked="checked" value="1">
                        <span class="checkmark"></span> זכר
                    </label>
                    <label class="form-radio-label">
                        <input type="radio" formControlName="sex" value="2">
                        <span class="checkmark"></span> נקבה
                    </label>
                    <control-messages [control]="f.sex"></control-messages>
                </div>
            </div>
</div>

    </div>





    <div class="row">
        <div class="col-md-6 col-xs-12">
            <div class="controls-group">
                <label mandatory>
                    שם פרטי
                </label>
                <div class="input-group">
                    <input type="text" class="form-control txt" maxlength="15" formControlName="first_name" placeholder="עברית"
                    />
                    <app-virtual-keyboard [control]="f.first_name" id="vk_first_name"></app-virtual-keyboard>
                </div>
                    <control-messages [control]="f.first_name"></control-messages>
                </div>
            </div>

        <div class="col-md-6 col-xs-12">
            <div class="controls-group">
                <label mandatory>
                    שם משפחה
                </label>
                <div class="input-group">
                <input type="text" class="form-control txt" maxlength="17" formControlName="last_name" placeholder="עברית"
                    />
                <app-virtual-keyboard [control]="f.last_name" id="vk_last_name"></app-virtual-keyboard>                 
                </div>
            <control-messages [control]="f.last_name"></control-messages>
            </div>
</div>

</div>

    <div class="row">
        <div class="col-md-6 col-xs-12">
            <div class="controls-group">
                <label mandatory>
                    שם פרטי
                </label>
                <div class="input-group">
                    <input type="text" class="form-control txt" maxlength="15" formControlName="first_name_eng" placeholder="אנגלית - כפי שרשום בדרכון"
                    />
                    <control-messages [control]="f.first_name_eng"></control-messages>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-xs-12">
            <div class="controls-group">
                <label mandatory>
                    שם משפחה
                </label>
                <div class="input-group">
                            <input type="text" class="form-control txt" maxlength="17" formControlName="last_name_eng" placeholder="אנגלית - כפי שרשום בדרכון"
                    />
                            <control-messages [control]="f.last_name_eng"></control-messages>
                        </div>
                    </div>
                </div>
            </div>



    <div class="row">
            <div class="col-md-6 col-xs-12">
            <div class="controls-group">
                <label mandatory>
                    תאריך לידה
                </label>
                <div class="input-group">
                    <input type="text" class="form-control datepicker" autocomplete="off" bsDatepicker [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
                        #dpd="bsDatepicker" formControlName="birth_date">
                    <span class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </span>
                    </span>
                    <control-messages [control]="f.birth_date"></control-messages>
                </div>
                </div>
            </div>
        <div class="col-md-6 col-xs-12">
            <div class="controls-group">
                <label mandatory>
                    תאריך חזרה משוער
                </label>
                <div class="input-group">
                    <input type="text" class="form-control datepicker" autocomplete="off" bsDatepicker [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
                        #dpd="bsDatepicker" formControlName="returning_date">
                    <span class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </span>
                    </span>
                    <control-messages [control]="f.returning_date"></control-messages>
                </div>
            </div>
        </div>
        </div>
</div>